import { useEffect } from 'react';
import { loadIndustrySectors } from '../../actions/common';
import { useAppDispatch, useAppSelector } from '../../reducers';
import { getIndustryOptions, getSectorOptions } from './utils';

export const useIndustrySector = (selectedSectorText: string | undefined) => {
  const dispatch = useAppDispatch();
  const industrySectors = useAppSelector((state) => state.industrySectors.data) || [];

  useEffect(() => {
    dispatch(loadIndustrySectors());
  }, [dispatch]);

  const sectorOptions = getSectorOptions(industrySectors);
  const industryOptions = getIndustryOptions(industrySectors, selectedSectorText);

  return { sectorOptions, industryOptions };
};
